import { cn } from '@/utils/utils';
import './index.scss';
import { DashboardListType } from '@/types/enums';
import { useTranslation } from 'react-i18next';
import { Value } from '@/types/dashboard';
import { formatLargeNumber } from '@/utils/formatNumber';

interface BikeStatusCardProps {
    dashboardListType: DashboardListType,
    icon: string,
    backgroundColor: string,
    contents?: Value[],
    onViewDetail: Function,
    imgClassName?: string
}

export default function BikeStatusCard({
    dashboardListType,
    icon,
    backgroundColor,
    contents = [],
    onViewDetail,
    imgClassName
}: BikeStatusCardProps) {
    // hook
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'rounded-base h-48 bg-cover bg-center bg-no-repeat text-[#ffffff] font-semibold flex flex-col',
                backgroundColor
            )}
        >
            {/* Header  */}
            <div className='flex border-b border-[#ffffff] border-opacity-50 h-[60px] gap-6'>
                <div className='flex-1 px-2 border-opacity-50 flex items-center'>
                    <img src={icon} alt='' className={cn(imgClassName)} />
                </div>
                <div className='border-l border-[#ffffff] px-2 flex justify-center items-center'>
                    <span className='glow-text text-fs-mid16 cursor-pointer !whitespace-nowrap' onClick={() => onViewDetail(dashboardListType)}>
                        {t('dashboard.view_details')}
                    </span>
                </div>
            </div>

            {/* Content  */}
            <div className='flex-1 flex justify-center items-center w-full'>
                {contents?.length > 0 && (
                    <div
                        className={cn(
                            'w-full',
                            contents?.length > 0 && `grid grid-cols-${contents?.length}`
                        )}
                    >
                        {contents.map(({ title, value }, index) => (
                            <div
                                key={index}
                                className='flex flex-col justify-center items-center border-r border-[#ffffff] border-opacity-50 last:border-none px-2'
                            >
                                <div className='pb-2 text-fs-mid16 text-center'>{title}</div>
                                <div className='w-full text-[36px] leading-[42px] truncate text-center'>
                                    {formatLargeNumber(value)}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
